import React from 'react';

import { Code } from '@atlaskit/code';
import Lozenge from '@atlaskit/lozenge';
import { Text } from '@atlaskit/primitives/compiled';
import { Table, TBody, TD, TH, THead, TR } from '@atlaskit/table/primitives';

import HorizontalScrollContainer from '../horizontal-scroll-container';
import CollapsingTopMargin from '../utils/collapsing-top-margin';

interface Row {
	name: string;
	usage: 'required' | 'optional' | 'do not use';
	description: string;
}

const data: Row[] = [
	{
		name: 'Headline',
		usage: 'required',
		description: 'Brief, direct, and hooks the user on the intent. No more than 2~3 words.',
	},
	{
		name: 'Carat',
		usage: 'required',
		description: 'Points to the referenced UI element.',
	},
	{
		name: 'Media',
		usage: 'optional',
		description: '295x135px image or video. Use judiciously.',
	},
	{
		name: 'Body',
		usage: 'required',
		description: 'Briefly elaborates on the intent.',
	},
	{
		name: 'StepCount',
		usage: 'required',
		description: 'Use step count for multi step spotlights.',
	},
	{
		name: 'DismissControl',
		usage: 'required',
		description:
			'All spotlight steps should have a dismiss control to allow the user to exit at any time.',
	},
	{
		name: 'ShowMoreControl',
		usage: 'optional',
		description:
			'3 - dot menu (for ad controls). Allows the user to opt out of the spotlight or understand why they are seeing it.',
	},
	{
		name: 'PrimaryAction',
		usage: 'required',
		description: 'One clear next action. “Next”, “Done” for tours.',
	},
	{
		name: 'SecondaryAction',
		usage: 'required',
		description: 'One clear previous action. “Back, “Prev" for tours.',
	},
];

const appearanceMap = {
	required: 'removed',
	optional: 'success',
	'do not use': 'removed',
} as const;

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const MultiStepSpotlightTable = ({ testId }: { testId?: string }) => {
	return (
		<CollapsingTopMargin>
			<HorizontalScrollContainer>
				<Table testId={testId}>
					<THead>
						<TR isBodyRow={false}>
							<TH>Name</TH>
							<TH>Usage</TH>
							<TH>Description</TH>
						</TR>
					</THead>
					<TBody>
						{data.map((row) => {
							return (
								<TR key={row.name}>
									<TD>
										<Code>{row.name}</Code>
									</TD>
									<TD>
										<Lozenge isBold appearance={appearanceMap[row.usage]}>
											{row.usage}
										</Lozenge>
									</TD>
									<TD>
										<Text>{row.description}</Text>
									</TD>
								</TR>
							);
						})}
					</TBody>
				</Table>
			</HorizontalScrollContainer>
		</CollapsingTopMargin>
	);
};
